
import * as  moment from "moment";
import { CRUDColumn } from '../../crud-dom/crud-column';
import * as pdfMake from "pdfmake"
//NECESSARIO RIALLACCIAMENTO DEI FONT DI PDFMAKE PER POTER SCARICARE IL FILE
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { PipeTransform } from '@angular/core';
//import { AppInfoService } from 'app/core/gui/Services/app-info.service';
import { Filtro } from "../../filtri/filtri.type";
import { DynamicPipeInstantiator } from "@alfercom/common-pipes";
import { TranslateService } from "@ngx-translate/core";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export interface SpreadSheetCol {
  name: string;
  prop: string;
  pipe: any;
  color?: string;
  bold?: boolean;
  size?: boolean;
  cellClass?: string;
  groupedColumns?: CRUDColumn[];
  isGroupedColumn?: boolean;
}

export interface InitSpreadSheetExporter {
  rows?: any[];
  map?: { map: any; context?: any };
  filter?: { filter: any; context?: any };
  columns: any[];
  sheetName?: string;
  author?: string;
  maxColumnLenght?: number;
}

export class PDFExporter {
  private rawRows: any[] = [];
  private rows: any[] = [];

  private map: any;
  private mapContext: any;
  private filter: any;
  private filterContext: any;

  private columns: SpreadSheetCol[] = [];
  private maxColumnLenght: number;

  // private sheetName: string = 'Dati Esportati '+moment().format("DD-MM-YYYY");
  // private sheetFiltri: string = 'Filtri Applicati';
  // private addDateTimePrefix: boolean = false;
  private author: string = 'unknown';

  private fileNameDefault: string | undefined; //FEPB_CRUDPDFEXPORTER_FILENAMEDEFAULT: 'Esportazione effettuata in data';
  private title: string | undefined; //FEPB_CRUDPDFEXPORTER_TITLE: 'Esportazione effettuata in data'
  private footerText: string | undefined; //FEPB_CRUDPDFEXPORTER_FOOTER: 'Documento generato tramite Rilancio Italia 2020 - www.rilancioitalia2020.it -  by www.alfercom.com'
  private filtriPrefix: string | undefined; //FEPB_CRUDPDFEXPORTER_FILTERPREFIX: 'FILTRI APPLICATI: '
  // private exportType: 'xls' | 'xlsx' | 'csv' | 'txt' = 'xls';

  private filtriApplicati: Filtro[] = null;

  private logo_cliente: any = null;

  private translateServiceRef: TranslateService | undefined;
  private locale: string | undefined;

  constructor() {//private guiService: AppInfoService
    // if (this.guiService) {
    //   this.guiService.getLogoObservable().subscribe(logo => {
    //     if (logo) {
    //       this.logo_cliente = logo.base64Head + "" + logo.base64;
    //     } else {
    //       this.logo_cliente = null;
    //     }
    //   });
    // }
    this.logo_cliente = null;
  }

  parse() {
    let r = this.rawRows;
    if (this.filter) {
      r = this.rawRows.filter(this.filter, this.filterContext);
    }
    if (this.map) {
      r = this.rawRows.map(this.map, this.mapContext);
    }
    this.rows = r;
  }

  init(params: InitSpreadSheetExporter) {
    if (params.author) {
      this.author = params.author;
    }

    if (params.rows) {
      this.rawRows = [];
      this.rawRows = [...params.rows];
    }
    // if (params.sheetName) {
    //   this.sheetName = params.sheetName;
    // }
    if (params.maxColumnLenght) {
      this.maxColumnLenght = params.maxColumnLenght;
    }
    if (params.columns) {
      this.columns = [];
      this.columns = [...params.columns];
      if (this.maxColumnLenght) {
        //INIT MAX COLOMUN LENGTH
        let arr = [];
        let lunghezza = this.columns.length;
        let itemsToRemove = lunghezza - this.maxColumnLenght;
        if (itemsToRemove > 0) {
          let arr = [...this.columns];
          arr.splice(this.maxColumnLenght, itemsToRemove); //NUMERO MASSIMO DI COLONNE-1 = ULTIMA COLONNA VISIBILE
          this.columns = [...arr];
        }
      }
    }
    if (params.map) {
      this.setMapFunction(params.map.map, params.map.context);
    }
    if (params.filter) {
      this.setFilterFunction(params.filter.filter, params.filter.context);
    }
  }

  setFiltriApplicati(filtri: Filtro[]) {
    this.filtriApplicati = [...filtri];
  }

  setMapFunction(map, context) {
    this.map = map;
    this.mapContext = context;
  }

  setFilterFunction(filter, context) {
    this.filter = filter;
    this.filterContext = context;
  }

  setRows(rows: any[]) {
    this.rawRows = [];
    this.rawRows = [...rows];
  }

  getFiltriLabel() {
    let label = this.filtriPrefix;
    if (this.filtriApplicati) {
      for (let filtro of this.filtriApplicati) {
        label += filtro.label + ', ';
      }
    }

    return label;
  }

  make() {
    let table = [];
    const title = this.title;
    const footerText = this.footerText;
    table.push(this.makeHeader());
    table.push(...this.makeBody());

    let filtriLabel = this.getFiltriLabel();
    const variableBase64 = base64_logo_pdf;
    const logo_cliente = this.logo_cliente;
    let dataImgLogoCliente = {};
    if (logo_cliente) {
      dataImgLogoCliente = {
        image: logo_cliente,
        fit: [100, 50],
        width: '50%',
        alignment: 'right'
      }
    }
    let docDefinition = {
      pageSize: 'A4',
      pageMargins: [20, 70, 20, 20],
      defaultStyle: { fontSize: 9 },
      header: function () {
        return {
          //intestazione immagine più titolo e sottotitolo
          margin: [20, 20, 20, 0],
          columns: [
            {
              image: variableBase64,
              fit: [100, 50],
              width: '50%'
            },
            dataImgLogoCliente
            // {
            //   image: logo_cliente,
            //   fit: [100, 50],
            //    width: '50%',
            //    alignment:'right'
            // },
            // {
            //   margin: [5, 5, 5, 5],
            //   text: [
            //     {
            //       text: intestazioneTitle,
            //       fontSize: 12,
            //       bold: true,
            //       alignment: "right",
            //       color: "green"
            //     },
            //     {
            //       text: intestazioneSubTitle,
            //       fontSize: 11,
            //       bold: true,
            //       alignment: "right",
            //     },
            //     {
            //       text: intestazione,
            //       fontSize: 9,
            //       alignment: "right",
            //     },
            //   ]
            // }
          ]
        };
      },
      footer: function (currentPage, pageCount) {
        return {
          columns: [
            { text: footerText, fontSize: 6, alignment: 'left', margin: [25, 0, 20, 0] },
            {
              //numero pagina
              text: currentPage.toString() + '/' + pageCount,
              alignment: 'right',
              margin: [0, 0, 20, 25]
            }
          ]
        };
      },
      content: [
        {
          table: {
            headerRows: 0,
            widths: ['*'],
            body: [
              [{ text: title + moment().format("DD/MM/YYYY"), style: 'header' }],
              [{ text: filtriLabel }],
              [{ text: '', style: 'space' }],
              [
                {
                  table: {
                    headerRows: 1,
                    body: table
                  },
                  layout: {
                    hLineColor: function (i, node) {
                      return (i === 0) ? '#004979' : '#dddddd';
                    },
                    vLineColor: '#dddddd',
                    fillColor: function (i, node) {
                      return (i === 0) ? '#f9f9f9' : '#ffffff';
                    },
                    // fillColor:"#f9f9f9",
                  }
                },
              ]
            ]
          },
          layout: {
            defaultBorder: false,
          }
        }
      ],
      styles: {
        header: {
          fontSize: 12,
          bold: true
        },
        space: {
          margin: 3
        },
        headerStyle: {
          fillColor: "#f9f9f9",
          color: "#015a2c",
          bold: true
        },
      },
      pageOrientation: 'landscape'
    };

    return docDefinition;
  }

  makeHeader() {
    let arr = [];
    for (let i in this.columns) {
      if (this.columns[i].isGroupedColumn) {
        for (let el of this.columns[i].groupedColumns) {
          arr.push(this.columns[i].name + ' - ' + el.name);
        }
      } else {
        arr.push(this.columns[i].name);
      }
    }

    return arr;
  }

  makeBody() {
    let content = [];
    for (let i in this.rows) {
      let arr = [];
      for (let c in this.columns) {
        if (this.columns[c].isGroupedColumn) {
          for (let el of this.columns[c].groupedColumns) {
            let value: any = this.columns[c].pipe ?
              this.pipeValue(this.columns[c].pipe, this.rows[i][this.columns[c].prop][el.prop]) :
              //this.columns[c].pipe.transform(this.rows[i][this.columns[c].prop][el.prop]) :
              this.rows[i][this.columns[c].prop][el.prop];
            value = value == null || value == undefined ? '-' : value;
            if (this.columns[c].cellClass) {
              if (this.columns[c].cellClass == "text-right") {
                let tmpVal = value;
                value = {};
                value =
                {
                  text: tmpVal,
                  alignment: 'right'
                }
              }
            }
            arr.push(value);
          }
        } else {
          let value: any = this.columns[c].pipe ?
            this.pipeValue(this.columns[c].pipe, this.rows[i][this.columns[c].prop]) :
            //this.columns[c].pipe.transform(this.rows[i][this.columns[c].prop]) : 
            this.rows[i][this.columns[c].prop];
          value = value == null || value == undefined ? '-' : value;
          if (this.columns[c].cellClass) {
            if (this.columns[c].cellClass == "text-right") {
              let tmpVal = value;
              value = {};
              value =
              {
                text: tmpVal,
                alignment: 'right'
              }
            }
          }
          arr.push(value);
        }
      }
      content.push(arr);
    }
    return content;
  }

  private pipeValue(pipeName, value) {
    const pipe: PipeTransform = pipeName && this.locale ? DynamicPipeInstantiator.getPipe(pipeName, [this.locale]) : null;
    if (pipe) {
      try {
        return pipe.transform(value);
      } catch (e) {
        return '-';
      }
    }
    return value;
  }

  export(type = 'pdf', fileName: string = this.fileNameDefault, rows: any[] = null) {
    if (rows) {
      this.setRows(rows);
      this.parse();
    }
    const docDefinition = this.make();
    let filename: string = fileName + '.pdf';
    pdfMake.createPdf(docDefinition).download(filename);
  }

  /**
   * 
   * @param translateService 
   * @param locale 
   */
  initMultiLang(translateService: TranslateService = undefined, locale: string = undefined) {
    this.translateServiceRef = translateService;
    this.locale = locale;
    this.getI18nCaptions();
  }

  /**
   * 
   */
  getI18nCaptions() {
    if (this.translateServiceRef) {
      this.title = this.translateServiceRef.instant('FEPB_CRUDPDFEXPORTER_TITLE');
      this.footerText = this.translateServiceRef.instant('FEPB_CRUDPDFEXPORTER_FOOTER');
      this.filtriPrefix = this.translateServiceRef.instant('FEPB_CRUDPDFEXPORTER_FILTERPREFIX');
      this.fileNameDefault = this.translateServiceRef.instant('FEPB_CRUDPDFEXPORTER_FILENAMEDEFAULT');
    }
  }
}

export const base64_logo_pdf = null;//LOGO_PDF;

